import { zapamietajPulpit } from "./pamiecPulpitu";
import { RODZAJE_SPRAW, STANY_KONCOWE, ZRODLA, dataPl, etykieta, odmien, zdanieOTerminie } from "./slowaWykazu";

/**
 * [ui1006, paczka KSC, projekt 3.2] ŹRÓDŁA STARTU „Do załatwienia” — TRZY odczyty (sufit `sufitOdczytowStartu: 3`):
 *   • `pulpit`  — `GET /pulpit`: sprawy po terminie, źródła w awarii, terminy kalendarza do 14 dni; odpowiedź trafia do
 *                 pamięci pulpitu (kafle nagłówka i blok „Spółki” czytają ją bez drugiego odczytu);
 *   • `sprawy`  — `GET /sprawy?tylkoOtwarte=true`: sprawy z terminem do 7 dni, sprawy „do wniosku” bez wniosku (sklejone per
 *                 spółka) i wnioski w toku bez zaświadczenia (sklejone per wniosek — serwer wie tylko tyle, D-23);
 *   • `prawo`   — `GET /prawo`: zmiany prawa do przeglądu.
 * Woła je POWŁOKA (`useZrodlaStartu`), nigdy miejsce (N-12). Klient API ładowany leniwie, żeby rejestr (czytany też przez
 * zapadki tras) nie ciągnął warstwy HTTP.
 * Wiersz: `{ id, ton, co, dlaczego, przycisk: { etykieta „Otwórz / Przejdź do / Zobacz … →”, adres względny }, obszar, rodzaj,
 * sklejone(n) }` — każdy prowadzi od razu na obiekt i część, której dotyczy (Z-18).
 */
const api = () => import("../../api/wykazKscApi").then((m) => m.default);
/* Część karty spółki z potwierdzeniem zgodności (wartość `?widok=` bez zmian — stoi w linkach). */
const CZESC_POTWIERDZENIA = "atestacja";

const otwarta = (sp) => !STANY_KONCOWE.includes(sp.status);

const coSieZmienilo = (sp) => `${sp.companyNazwa || "Spółka"} — ${sp.poleNazwa ? `zmienił się ${sp.poleNazwa.toLocaleLowerCase("pl")}` : etykieta(RODZAJE_SPRAW, sp.rodzaj).toLocaleLowerCase("pl")}`;

const zdanieTerminu = (sp) => {
    const z = zdanieOTerminie(sp);
    if (!z) return "Termin nie został jeszcze policzony.";
    if (sp.poTerminie) return `Termin minął ${z.replace(/ po terminie$/, " temu")}.`;
    return `Termin ${z} (${dataPl(sp.terminDo)}).`;
};

export const ZRODLO_PULPIT = {
    id: "pulpit",
    nazwa: "pulpit wykazu",
    klucz: "WykazKscPodglad",
    pobierz: () => api().then((a) => a.pulpit()).then((r) => { const dane = (r && r.data) || {}; zapamietajPulpit(dane); return dane; }),
    naWiersze: (dane) => {
        const poTerminie = Array.isArray(dane.poTerminie) ? dane.poTerminie : [];
        const awarie = Array.isArray(dane.zrodlaWAwarii) ? dane.zrodlaWAwarii : [];
        const terminy = (Array.isArray(dane.najblizszeTerminy) ? dane.najblizszeTerminy : []).filter((t) => t.dniDo != null && t.dniDo <= 14);
        const wiersze = [
            ...poTerminie.map((sp) => ({
                id: `sprawa-po-terminie:${sp.id}`,
                ton: "po-terminie",
                co: coSieZmienilo(sp),
                dlaczego: zdanieTerminu(sp),
                pelnaData: dataPl(sp.terminDo),
                przycisk: { etykieta: "Otwórz sprawę →", adres: `./sprawy?sprawa=${sp.id}&czesc=decyzja` },
                obszar: "sprawy",
                rodzaj: "sprawa-po-terminie",
                sklejone: (n) => ({ co: `${n} ${odmien(n, ["sprawa", "sprawy", "spraw"])} po terminie`, dlaczego: "Każda czeka na decyzję, a termin ustawowy już minął.", przycisk: { etykieta: "Otwórz sprawy →", adres: "./sprawy?widok=po-terminie" } }),
            })),
            ...awarie.map((z) => ({
                id: `awaria:${z.zrodlo}:${z.klucz}`,
                ton: "po-terminie",
                plakietka: "awaria",
                co: `Źródło ${etykieta(ZRODLA, z.zrodlo)} nie odpowiada`,
                dlaczego: z.ostatniSukcesAt ? `Ostatni udany odczyt ${dataPl(z.ostatniSukcesAt)}; kolejne błędy: ${z.kolejneBledy ?? 0}.` : "Źródło nie oddało jeszcze żadnego odczytu.",
                przycisk: { etykieta: "Zobacz źródło →", adres: `./zrodla?zrodlo=${encodeURIComponent(z.zrodlo)}` },
                obszar: "zrodla",
                rodzaj: "awaria-zrodla",
                sklejone: (n) => ({ co: `${n} ${odmien(n, ["źródło", "źródła", "źródeł"])} w awarii`, dlaczego: "System nie ma skąd brać części danych.", przycisk: { etykieta: "Zobacz źródła →", adres: "./zrodla" } }),
            })),
            ...terminy.map((t) => ({
                id: `termin:${t.kod}`,
                ton: "pilne",
                plakietka: t.dniDo === 0 ? "dziś" : `za ${t.dniDo} ${odmien(t.dniDo, ["dzień", "dni", "dni"])}`,
                co: t.opis,
                dlaczego: `Termin z ustawy: ${t.przepis || "kalendarz ustawowy"} (${dataPl(t.data)}).`,
                pelnaData: dataPl(t.data),
                przycisk: /atest|potwierdz/i.test(String(t.kod)) && t.companyId
                    ? { etykieta: "Przejdź do potwierdzenia →", adres: `./spolka/${t.companyId}?widok=${CZESC_POTWIERDZENIA}` }
                    : { etykieta: "Zobacz termin →", adres: "./terminy" },
                obszar: "terminy",
                rodzaj: "termin-kalendarza",
                sklejone: (n) => ({ co: `${n} ${odmien(n, ["termin", "terminy", "terminów"])} z ustawy w najbliższych 14 dniach`, dlaczego: "Każdy ma datę w kalendarzu ustawowym.", przycisk: { etykieta: "Zobacz terminy →", adres: "./terminy" } }),
            })),
        ];
        return { wiersze, liczniki: { zrodla: awarie.length, terminy: terminy.length } };
    },
};

export const ZRODLO_SPRAWY = {
    id: "sprawy",
    nazwa: "otwarte sprawy",
    klucz: "WykazKscPodglad",
    pobierz: () => api().then((a) => a.sprawy({ tylkoOtwarte: true })).then((r) => (Array.isArray(r && r.data) ? r.data : [])),
    naWiersze: (sprawy) => {
        const otwarte = sprawy.filter(otwarta);
        /* „Pilne” = sprawa CZEKAJĄCA NA DECYZJĘ (stan „nowa”) z terminem do 7 dni. Sprawa „do wniosku” ma już decyzję — stoi wyłącznie
           w wierszu „… czeka na wniosek” (poprawki po przeglądzie: wpadała dwa razy, raz z „Otwórz sprawę →” na część „Decyzja”). */
        const pilne = otwarte.filter((sp) => sp.status === "nowa" && !sp.poTerminie && sp.dniDoTerminu != null && sp.dniDoTerminu >= 0 && sp.dniDoTerminu <= 7 && !sp.wniosekId);
        const doWniosku = otwarte.filter((sp) => sp.status === "do_wniosku" && !sp.wniosekId);
        const wToku = otwarte.filter((sp) => !!sp.wniosekId);

        const perSpolka = new Map();
        doWniosku.forEach((sp) => { const k = String(sp.companyId); perSpolka.set(k, [...(perSpolka.get(k) || []), sp]); });
        const perWniosek = new Map();
        wToku.forEach((sp) => { const k = String(sp.wniosekId); perWniosek.set(k, [...(perWniosek.get(k) || []), sp]); });
        const najblizszy = (lista) => lista.reduce((a, sp) => (a == null || (sp.dniDoTerminu != null && sp.dniDoTerminu < a) ? sp.dniDoTerminu : a), null);
        const zaDni = (n) => (n == null ? "termin niepoliczony" : (n < 0 ? `${-n} ${odmien(-n, ["dzień", "dni", "dni"])} po terminie` : (n === 0 ? "termin dziś" : `najbliższy termin za ${n} ${odmien(n, ["dzień", "dni", "dni"])}`)));

        const wiersze = [
            ...pilne.map((sp) => ({
                id: `sprawa-pilna:${sp.id}`,
                ton: "pilne",
                plakietka: sp.dniDoTerminu === 0 ? "dziś" : `za ${sp.dniDoTerminu} ${odmien(sp.dniDoTerminu, ["dzień", "dni", "dni"])}`,
                co: coSieZmienilo(sp),
                dlaczego: zdanieTerminu(sp),
                pelnaData: dataPl(sp.terminDo),
                przycisk: { etykieta: "Otwórz sprawę →", adres: `./sprawy?sprawa=${sp.id}&czesc=decyzja` },
                obszar: "sprawy",
                rodzaj: "sprawa-pilna",
                sklejone: (n) => ({ co: `${n} ${odmien(n, ["sprawa", "sprawy", "spraw"])} z terminem w tym tygodniu`, dlaczego: "Każda czeka na decyzję, czy zgłaszamy zmianę ministrowi.", przycisk: { etykieta: "Otwórz sprawy →", adres: "./sprawy" } }),
            })),
            ...[...perSpolka.entries()].map(([companyId, lista]) => ({
                id: `do-wniosku:${companyId}`,
                ton: "pilne",
                plakietka: "do wniosku",
                co: `${lista[0].companyNazwa || "Spółka"} — ${lista.length} ${odmien(lista.length, ["sprawa czeka", "sprawy czekają", "spraw czeka"])} na wniosek`,
                dlaczego: `Decyzja „zgłaszamy” zapadła, wniosku jeszcze nie ma; ${zaDni(najblizszy(lista))}.`,
                przycisk: { etykieta: "Przejdź do wniosku →", adres: `./wnioski?spolka=${companyId}&kreator=wniosek&krok=1` },
                obszar: "wnioski",
                rodzaj: "do-wniosku",
                sklejone: (n) => ({ co: `${n} ${odmien(n, ["spółka czeka", "spółki czekają", "spółek czeka"])} na wniosek`, dlaczego: "Sprawy mają decyzję „zgłaszamy”, a wniosku jeszcze nie ma.", przycisk: { etykieta: "Przejdź do wniosków →", adres: "./wnioski" } }),
            })),
            ...[...perWniosek.entries()].map(([wniosekId, lista]) => ({
                id: `wniosek-w-toku:${wniosekId}`,
                ton: "pilne",
                plakietka: "w toku",
                co: `${lista[0].companyNazwa || "Spółka"} — wniosek w toku, ${lista.length} ${odmien(lista.length, ["sprawa", "sprawy", "spraw"])}, ${zaDni(najblizszy(lista))}`,
                dlaczego: "Brak zaświadczenia — podpisz wniosek, złóż go w portalu i wgraj zaświadczenie.",
                przycisk: { etykieta: "Otwórz wniosek →", adres: `./wnioski?spolka=${lista[0].companyId}&wniosek=${wniosekId}` },
                obszar: "wnioski",
                rodzaj: "wniosek-w-toku",
                sklejone: (n) => ({ co: `${n} ${odmien(n, ["wniosek", "wnioski", "wniosków"])} w toku bez zaświadczenia`, dlaczego: "Każdy czeka na podpis, złożenie w portalu i zaświadczenie.", przycisk: { etykieta: "Otwórz wnioski →", adres: "./wnioski?widok=w-toku" } }),
            })),
        ];
        return { wiersze, liczniki: { sprawy: otwarte.length, wnioski: perWniosek.size + perSpolka.size } };
    },
};

export const ZRODLO_PRAWO = {
    id: "prawo",
    nazwa: "zmiany prawa",
    klucz: "WykazKscPodglad",
    pobierz: () => api().then((a) => a.prawo()).then((r) => (Array.isArray(r && r.data) ? r.data : [])),
    naWiersze: (zdarzenia) => {
        const nowe = zdarzenia.filter((z) => z.stan === "nowe");
        return {
            wiersze: nowe.map((z) => ({
                id: `prawo:${z.id}`,
                ton: "do-przejrzenia",
                co: z.tytul,
                dlaczego: `Zmiana wykryta ${dataPl(z.wykrytoAt)} w źródle ${etykieta(ZRODLA, z.zrodlo)}.`,
                pelnaData: dataPl(z.wykrytoAt),
                przycisk: { etykieta: "Otwórz zmianę →", adres: `./prawo?zdarzenie=${z.id}&czesc=przeglad` },
                obszar: "prawo",
                rodzaj: "zmiana-prawa",
                odkladalny: true,
                sklejone: (n) => ({ co: `${n} ${odmien(n, ["zmiana prawa", "zmiany prawa", "zmian prawa"])} do przeglądu`, dlaczego: "Każdą trzeba ocenić: dotyczy nas czy nie.", przycisk: { etykieta: "Otwórz zmiany →", adres: "./prawo?widok=do-przegladu" } }),
            })),
            liczniki: { prawo: nowe.length },
        };
    },
};

export const ZRODLA_STARTU_WYKAZU = [ZRODLO_PULPIT, ZRODLO_SPRAWY, ZRODLO_PRAWO];

export default ZRODLA_STARTU_WYKAZU;
